import React, { Component } from "react";
import { AddApplicationContextProvider } from "../../context/AddApplicationContext";
import AddApplication from "./AddApplication";
const Applications = () => {
  return (
    <>
      <AddApplicationContextProvider>
        <AddApplication />
      </AddApplicationContextProvider>
    </>
  );
};

export default Applications;
